import { FC } from 'react';
import { DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';

import DataGridPro from '../../../../../components/CDGridPro';

import { DspGeoLocation } from '../../../../../types/DspGeoLocation';

type CampaignAdGroupGeoLocationTargetingDataGridProps = Omit<DataGridProProps, 'columns' | 'rows'> & {
    rows: DspGeoLocation[];
};

const CampaignAdGroupGeoLocationTargetingDataGrid: FC<CampaignAdGroupGeoLocationTargetingDataGridProps> = ({
    rows,
    ...props
}) => {
    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Zip Codes',
            flex: 1,
            filterable: false,
        },
    ];

    const getRowId = (row: DspGeoLocation): string | number => {
        return row.geoId as string;
    };

    return (
        <DataGridPro
            // Overridable props
            pageSize={5}
            {...props}
            disableColumnPinning
            getRowId={getRowId}
            columns={columns}
            rows={rows}
            slots={{
                toolbar: null,
            }}
        />
    );
};
export default CampaignAdGroupGeoLocationTargetingDataGrid;
